import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import dayjs, { Dayjs } from "dayjs";
import { formatDate, formatDateTime } from "../../../util/FormatUtil";
export const YesNoFormat = (props) => {
    const text = props.value ? "Yes" : "No";
    return (_jsx(_Fragment, { children: text }));
};
export const formatNumber = (amount, minimumFractionDigits = 2, maximumFractionDigits = 3) => {
    return Intl.NumberFormat("en-AU", {
        style: "decimal",
        minimumFractionDigits,
        maximumFractionDigits,
    }).format(amount);
};
const CURRENCY_AUD_NUMBER_FORMAT = Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
});
const CURRENCY_AUD_NO_CENTS_NUMBER_FORMAT = Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: 0,
    roundingMode: 'halfCeil'
});
export const formatCurrency = (amount, roundToDollars = false) => {
    if (roundToDollars) {
        return CURRENCY_AUD_NO_CENTS_NUMBER_FORMAT.format(amount);
    }
    return CURRENCY_AUD_NUMBER_FORMAT.format(amount);
};
export const CurrencyFormat = ({ value, roundToDollars = false, }) => {
    if (value === 0) {
        return "$0.00";
    }
    if (!value) {
        return null;
    }
    let decimalVal;
    if (typeof value === 'number') {
        decimalVal = value;
    }
    else {
        decimalVal = parseFloat(value);
    }
    return (_jsx(_Fragment, { children: isNaN(decimalVal)
            ? _jsx(_Fragment, { children: "\u2014" })
            : _jsx(_Fragment, { children: formatCurrency(decimalVal, roundToDollars) }) }));
};
export const WholeNumberFormat = (props) => {
    if (!props.value) {
        return null;
    }
    const floatVal = parseFloat(props.value + "");
    if (isNaN(floatVal)) {
        return null;
    }
    return (_jsx(_Fragment, { children: floatVal }));
};
export const DateFormat = (props) => {
    const emptyVal = _jsx(_Fragment, { children: "\u2014" }); // || props.emptyVal;
    return (_jsx(_Fragment, { children: formatDate(props.value) || emptyVal }));
};
export const DateTimeFormat = (props) => {
    const emptyVal = _jsx(_Fragment, { children: "\u2014" }); // || props.emptyVal;
    return (_jsx(_Fragment, { children: formatDateTime(props.value) || emptyVal }));
};
export const PercentFormat = ({ value, precision = 2 }) => {
    if (typeof value !== 'number') {
        return null;
    }
    const floatVal = Math.round(value * Math.pow(10, precision + 4)) / Math.pow(10, precision + 2); // Try to fix Javascript precision issue
    if (isNaN(floatVal)) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [floatVal, "%"] }));
};
export const formatDriverNameWithPhoneNumber = (driver) => {
    let result = '';
    if (!driver) {
        return result;
    }
    if (driver.firstName) {
        result += driver.firstName;
    }
    if (driver.lastName) {
        result += ' ' + driver.lastName;
    }
    if (driver.mobileNo && driver.mobileNo.length > 0) {
        result += ' - ' + driver.mobileNo;
    }
    return result;
};
export const TimeOnlyFormat = (props) => {
    return (_jsx(_Fragment, { children: dayjs(props.value).format('HH:mm') }));
};
export const ElapsedMinutesFormat = (props) => {
    let value = props.value;
    if (!value) {
        return (_jsx(_Fragment, { children: "\u2014" }));
    }
    const isNegative = value < 0;
    if (isNegative) {
        value = value * -1;
    }
    const hours = Math.floor(value / 60);
    const min = value % 60;
    //console.log("ElapsedMinutesFormat.  value:" + value + " hours:" + hours+ " min:" + min);
    return (_jsxs(_Fragment, { children: [isNegative ? "-" : "", hours === 0 ?
                _jsx(_Fragment, { children: `${min} min` })
                :
                    _jsx(_Fragment, { children: min === 0 ? `${hours} hrs` : `${hours} hrs ${min} min` })] }));
};
